import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useDeleteDeviceById } from "../../../hooks/common/mutation";
import { useTranslation } from "react-i18next";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteDeviceModalProps {
  deviceId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteDeviceModal = ({
  deviceId,
  isOpen,
  onOpenChange,
}: DeleteDeviceModalProps) => {
  const {
    mutateAsync: DeleteDeviceById,
    isPending: isDeleteDeviceByIdLoading,
  } = useDeleteDeviceById();

  const { t } = useTranslation();

  const handleDeleteDevice = useCallback(async () => {
    try {
      const body = {
        encryptedId: deviceId.toString(),
      };

      await DeleteDeviceById(body);
      toast.success(t("deviceDeleted"));
    } catch (error: any) {
      if (
        error.result.deleteStatus ===
        DELETE_STATUSES.USED_IN_ACCESS_GROUP_DEVICES
      ) {
        toast.error(t("deviceNotDeletedUsedByAccessGroupDevice"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [DeleteDeviceById, t, deviceId, onOpenChange]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteDevice")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteDevice}
            isLoading={isDeleteDeviceByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteDeviceModal);
